import {baseUrl, setQueryParam} from 'src/utils/url';

class PdpSizeAvailabilityTest {
  constructor() {
    this.alternativesSectionLoaded = false;
    this.alternativesSelector = '.pc-Style-alternatives';
    this.alternativesContentSelector = '.pc-Style-alternatives-content';
    if ($(this.alternativesSelector).length > 0) {
      this.modifyPdpPage();
      this.fetchAlternatives = this.fetchAlternatives.bind(this);
      this.clickHeroColorsStockWarningLink =
        this.clickHeroColorsStockWarningLink.bind(this);
      if ($('#hero').data('alternativesPresent')) {
        this.addAlternativesSection();
        $(document).on('swatchselect.style.colorinteraction', (e, data) => {
          if (
            !ProductCatalog.QuickView.isQuickView() &&
            this.alternativesSectionLoaded
          ) {
            this.fetchAlternatives(data);
          }
        });
      }
      this.additionalOosMitigationTagging();
    }
  }

  modifyPdpPage() {
    this.changeColorSwatchHeader();
    this.changeSelectedColorDescription();
    this.changeSizingDescription();
    this.changePricingInfo();
  }

  additionalOosMitigationTagging() {
    const styleName = $('.pc-Style-productName.pc-Style-section-title').data(
      'styleName'
    );
    const eventCategory =
      ProductCatalog.IFrame.iframer() === 'ndx' ? 'ndx pdp' : 'pdp';
    $(document).on('click', '.pc-Style-hero-colors-stockWarning', (e) => {
      this.clickHeroColorsStockWarningLink(e, eventCategory, styleName);
    });
  }

  clickHeroColorsStockWarningLink(evt, category, label) {
    const linkText = evt.target.outerText;
    const coreOutLinkText = [
      "Check what's available in other colors",
      'try a different style.'
    ];
    const actions = ['color size availability', 'alternative styles'];
    const coreIndex = coreOutLinkText.indexOf(linkText);
    if (coreIndex !== -1) {
      CustomInk.Metrics.fireEvent({
        category: category,
        action: actions[coreIndex],
        label: label
      });
    }
  }

  addAlternativesSection() {
    this.observeAlternativeSection();
    if ($('#hero').data('complementsPresent')) {
      $('.pc-Style-complements.sb-Wrapper').addClass('stockAware');
    }
  }

  changeColorSwatchHeader() {
    $(`
      .pc-Style-hero-image,
      .pc-Style-hero-colors-count,
      .pc-ToolBar-ordQty,
      .pc-Style-hero-colors .pc-ToolBar-ordQty .pc-ToolBar-toggle-button
    `).addClass('oos');
    $('.pc-Style-hero-colors-count.oos').text('Colors:');
    $('.pc-Style-hero-colors-count, .pc-ToolBar-ordQty.oos').wrapAll(
      '<div class="pc-Style-hero-colors-header"></div>'
    );
  }

  changeSelectedColorDescription() {
    $(`
      .pc-Style-selectedColor,
      .pc-Style-selectedColor-identifier-text
    `).addClass('oos');
    $('.pc-Style-selectedColor-identifier-text.oos').text(
      'Sizes Available in:'
    );
    $('.pc-Style-selectedColor').insertAfter('.pc-Style-hero-colors-swatches');
  }

  changeSizingDescription() {
    $(`
      .pc-Style-hero-sizing,
      .pc-Style-hero-colors-sizeList,
      .pc-Style-hero-fitInfo
    `).addClass('oos');
    $(`
      .pc-Style-hero-sizing h4,
      .pc-Style-hero-sizeRange,
      .pc-Style-hero-sizing-availability,
      .pc-Style-hero-oos,
      .pc-Style-hero-sizing-lineup
    `).hide();
    $(`
      .pc-Style-hero-colors-sizeList,
      .pc-Style-hero-colors-stockWarning,
      .pc-Style-hero-fit-sizing-header,
      .pc-Style-hero-availability-link
    `).show();
  }

  changePricingInfo() {
    $('.pc-Style-hero-pricing-sizingLink').show();
    $('.pc-Style-hero-pricing, .pc-Style-hero-pricing-sizing-wrapper').addClass(
      'oos'
    );
    if (ProductCatalog.IFrame.isIframer('ndx')) {
      $('.pc-Style-hero-pricing-sizingLink').addClass('ndx');
    }
  }

  observeAlternativeSection() {
    const options = {rootMargin: '0px 0px 150px 0px'};
    const alternativesObserver = new IntersectionObserver(
      (entries, observer) => {
        return this.handleIntersect(entries, observer);
      },
      options
    );
    alternativesObserver.observe(
      document.querySelector(this.alternativesSelector)
    );
  }

  handleIntersect(entries, observer) {
    return entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        this.fetchAlternatives();
        this.alternativesSectionLoaded = true;
        observer.unobserve(document.querySelector(this.alternativesSelector));
      }
    });
  }

  fetchAlternatives(data) {
    $('.pc-Style-alternatives .spinner').show();
    let url = `${baseUrl()}/alternatives.html`;
    const productId = data ? data.id : $('.pc-Swatch.is-selected').data('id');
    url = setQueryParam('PK', productId, url);
    if (ProductCatalog.IFrame.iframer()) {
      url = setQueryParam('iframer', ProductCatalog.IFrame.iframer(), url);
    }
    return $.ajax(url, {
      type: 'GET',
      error: (jqXHR, textStatus, errorThrown) => {
        $(this.alternativesSelector).css({padding: 0});
        $(this.alternativesSelector).html('');
        $('.pc-Style-alternatives .spinner').hide();
      },
      success: (responseHtml) => {
        const $node = $(responseHtml).filter(this.alternativesContentSelector);
        if (!$.trim($node.html()).length) {
          $(this.alternativesSelector).css({padding: 0});
          $('.pc-Style-alternatives .spinner').hide();
          return;
        }
        $('.pc-Style-alternatives .spinner').hide();
        $(this.alternativesSelector).html(responseHtml);
        $('.pc-Style-alternatives-content')
          .children('.pc-ProductCard')
          .slice(4)
          .hide();
        return $(this.alternativesContentSelector)
          .find('.pc-lazyImage-isLoading')
          .each((idx, e) => {
            return ProductCatalog.ImageLazyLoader !== null
              ? ProductCatalog.ImageLazyLoader.lazyImageObserver.observe(e)
              : undefined;
          });
      }
    });
  }
}

jQuery(
  () => (ProductCatalog.PdpSizeAvailabilityTest = new PdpSizeAvailabilityTest())
);
